import QuestionValue from "./QuestionValue";

export default class QuestionValueUnitConversion extends QuestionValue {
    constructor(value, unit = "") {
        super(value);
        this._unit = unit;
    }

    toString() {
        return "" + this._value;// + this._unit;
    }

    get unit() {
        return this._unit;
    }
}